const allENV = {
  local: {
    baseURL: "http://localhost:3004/api/v2",
    imageURL: "https://visilant-pndy-upload-image.azurewebsites.net/api",
    ipURL: "https://api.ipstack.com",
    name: 'local'
  },
  visilant: {
    baseURL: "https://devapi.visilant.org/api/v2",
    imageURL: '',
    ipURL: "https://api.ipstack.com",
    name: 'visilant'
  },
  pndy: {
    baseURL: "https://pndyapi.visilant.org/api/v2",
    imageURL: "https://visilant-snc-upload-image-ghh9h0h3h2athtc9.centralindia-01.azurewebsites.net/api",
    ipURL: "https://api.ipstack.com",
    name: 'pndy'
  },
  img: {
    baseURL: "https://imgapi.visilant.org/api/v2",
    imageURL: 'https://visilant-prod-upload-image.azurewebsites.net/api',
    ipURL: "https://api.ipstack.com",
    name: 'img'
  },
  snc: {
    baseURL: "https://sncapi.visilant.org/api/v2",
    imageURL: 'https://visilant-pndy-upload-image.azurewebsites.net/api',
    ipURL: "https://api.ipstack.com",
    name: 'snc',
  },
  sceh: {
    baseURL: "https://scehapi.visilant.org/api/v2",
    imageURL: 'https://visilant-tvl-upload-image.azurewebsites.net/api',
    ipURL: "https://api.ipstack.com",
    name: 'sceh'
  }
};

function detectEnv() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return {
      baseURL: process.env.REACT_APP_API_BASE_URL,
      imageURL: process.env.REACT_APP_IMAGE_URL || '',
      ipURL: "https://api.ipstack.com",
      name: process.env.REACT_APP_ENV_NAME || 'custom'
    };
  }
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host === 'localhost' || host.startsWith('127.')) return allENV.local;
    if (host.includes('pndy')) return allENV.pndy;
    if (host.includes('img')) return allENV.img;
    if (host.includes('snc')) return allENV.snc;
    if (host.includes('sceh')) return allENV.sceh;
    if (host.includes('visilant')) return allENV.visilant;
  }
  return allENV.local;
}

export const Server = {
  ENV: detectEnv(),
};
